// src/utils/urlParse.js

(function attachUrlParsePolyfill(global) {
  // eslint-disable-next-line no-restricted-globals
  const g = global || (typeof window !== 'undefined' ? window : self);

  // Only add if missing to avoid surprising overrides
  if (typeof g.URL === 'function' && typeof g.URL.parse !== 'function') {
    /**
     * Node-style url.parse(input, parseQueryString = false, slashesDenoteHost = false)
     * This is a best-effort browser polyfill for common fields.
     */
    g.URL.parse = function urlParse(input, parseQueryString = false, _slashesDenoteHost = false) {
      // Support passing a base like Node’s WHATWG URL: url.parse('path', ... , ... , base)
      // If a base is needed in your app, call URL.parse(new URL(input, base).href, ...)
      const u = new g.URL(input, g.location?.origin || 'http://localhost');

      // Build a Node-like object
      const out = {
        protocol: u.protocol || null,                      // "https:"
        slashes: u.href.startsWith((u.protocol || '') + '//'),
        auth: (u.username || u.password) ? `${u.username}:${u.password}` : null,
        host: u.host || null,                              // "example.com:8080"
        port: u.port || null,                              // "8080"
        hostname: u.hostname || null,                      // "example.com"
        hash: u.hash || null,                              // "#hash"
        search: u.search || null,                          // "?a=1&b=2"
        query: u.search ? u.search.slice(1) : (parseQueryString ? {} : null), // string or {}
        pathname: u.pathname || null,                      // "/path"
        path: (u.pathname || '') + (u.search || ''),       // "/path?a=1"
        href: u.href,                                      // full href
      };

      if (parseQueryString && u.search) {
        const params = new URLSearchParams(u.search);
        const q = {};
        for (const [k, v] of params.entries()) {
          if (q[k] === undefined) q[k] = v;
          else if (Array.isArray(q[k])) q[k].push(v);
          else q[k] = [q[k], v];
        }
        out.query = q;
      }

      return out;
    };
  }

  // Provide a minimal `url` object with parse() for code calling url.parse(...)
  if (typeof g.url !== 'object' || typeof g.url.parse !== 'function') {
    g.url = g.url || {};
    g.url.parse = function (...args) {
      return g.URL.parse(...args);
    };
  }

  // Optional: add a tiny URL.format compatible helper for common cases
  if (typeof g.URL.format !== 'function') {
    g.URL.format = function format(obj) {
      // Supports the most common pieces
      const protocol = obj.protocol || '';
      const slashes = obj.slashes || protocol === 'http:' || protocol === 'https:';
      const auth = obj.auth ? `${obj.auth}@` : '';
      const host = obj.host || (obj.hostname ? (obj.port ? `${obj.hostname}:${obj.port}` : obj.hostname) : '');
      const pathname = obj.pathname || '';
      const search = obj.search || (obj.query && typeof obj.query === 'string' ? `?${obj.query}` : '');
      const hash = obj.hash || '';
      const pre = protocol ? protocol + (slashes ? '//' : '') : (slashes ? '//' : '');
      return `${pre}${auth}${host}${pathname}${search}${hash}`;
    };
  }
// eslint-disable-next-line no-undef
})(typeof globalThis !== 'undefined' ? globalThis : window);
